module.exports = __webpack_public_path__ + "Icono_Cotizacion-Bco_512px.png";